import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
// import PropTypes from "prop-types";
import { queuePad } from "../../utility";
import { useAntrian } from "./context";
import Receipt from "../../components/Receipt";

function LihatAntrian() {
  let componentRef = useRef();
  const { state, dispatch } = useAntrian();
  const renderReceipt = () => (
    <div
      style={{
        display: "none",
      }}
    >
      <Receipt
        data={state.antrian}
        type="Offline"
        ref={(el) => (componentRef = el)}
      />
    </div>
  );
  if (state.step === 5) {
    return (
      <div className="result">
        <h3>Berhasil!</h3>
        <div
          className="cta-group"
          style={{
            margin: "48px 0",
          }}
        >
          <ReactToPrint
            trigger={() => (
              <button className="cta" type="button">
                Cetak Ulang
              </button>
            )}
            content={() => componentRef}
            pageStyle={`
          @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;600&display=swap');
        `}
          />
          <button
            type="button"
            className="cta"
            onClick={() => {
              dispatch({
                type: "CLEAR",
              });
            }}
          >
            Selesai
          </button>
        </div>
        {renderReceipt()}
      </div>
    );
  }
  return (
    <div className="result">
      <h4>Nomor Antiran:</h4>
      <h1>{queuePad(state.antrian?.urutan)}</h1>
      <table>
        <tbody>
          <tr>
            <td>NIK</td>
            <td>:</td>
            <td>{state.antrian?.nik}</td>
          </tr>
          <tr>
            <td>Nama Lengkap</td>
            <td>:</td>
            <td>{state.antrian?.name}</td>
          </tr>
          <tr>
            <td>No HP</td>
            <td>:</td>
            <td>{state.antrian?.phone}</td>
          </tr>
          <tr>
            <td>Instansi yang dituju</td>
            <td>:</td>
            <td>{state.antrian?.nama_layanan}</td>
          </tr>
          <tr>
            <td>Layanan terkait</td>
            <td>:</td>
            <td>{state.antrian?.nama_sub_layanan}</td>
          </tr>
        </tbody>
      </table>

      <ReactToPrint
        trigger={() => (
          <button type="button" className="cta">
            Ambil
          </button>
        )}
        onBeforePrint={() => {
          dispatch({
            type: "SWITCH_STEP",
            to: 5,
          });
        }}
        content={() => componentRef}
        pageStyle={`
          @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;600&display=swap');
        `}
      />
      {renderReceipt()}
    </div>
  );
}

// LihatAntrian.propTypes = {};
export default LihatAntrian;
